wrapQueryRef